import { RefObject, useEffect } from 'react';

const useClickOutside = (
  ref: RefObject<HTMLElement>,
  handler: (event: MouseEvent | TouchEvent) => void
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const isLocalizeWidget = [
        'localize-widget',
        'localize-widget-langs',
      ].includes(((event?.target as Element)?.parentNode as HTMLElement)?.id);

      const isEmojiSelector =
        (event?.target as Element)?.nodeName.toUpperCase() ===
        'EM-EMOJI-PICKER';

      if (
        !ref?.current ||
        ref?.current.contains(event.target as Element) ||
        isLocalizeWidget ||
        isEmojiSelector
      ) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useClickOutside;
